import axios from "axios"
import { useBearStore } from "./stores/user"
import { getCookie } from "@/lib/utils/cookie"
import { API_BASE_URL } from "@/lib/constants/api"
import { initialUserProfile } from "./types/user"
import { toast } from "@/lib/utils/toast"

// Use the admin API URL since that's where your backend is running
export const axiosInstance = axios.create({
	baseURL: API_BASE_URL,
	timeout: 10000,
	headers: {
		"Content-Type": "application/json",
		"Accept": "application/json",
	},
})

// Add request interceptor
axiosInstance.interceptors.request.use(
	(config) => {
		// console.log('Request:', {
		// 	url: config.url,
		// 	method: config.method,
		// 	headers: config.headers,
		// 	data: config.data,
		// 	baseURL: config.baseURL // Log the baseURL to verify
		// })
		return config
	},
	(error) => {
		console.error('Request Error:', error)
		return Promise.reject(error)
	}
)

axiosInstance.interceptors.request.use((config) => {
	// Only add authorization header if we're in a browser environment
	// and the cookie is available. This prevents issues during build time.
	if (typeof window !== "undefined") {
		const token = getCookie("auth-token") || null
		if (token && token !== "undefined") {
			config.headers.Authorization = `Bearer ${token}`
		}
	} else {
		// In server-side rendering or build time, we may not have access to cookies
		// Skip authorization for now, or implement server-side token handling if needed
		console.log('Server-side request, skipping auth token')
	}
	return config
})

// Add response interceptor
axiosInstance.interceptors.response.use(
	(response) => {
		// Log the response for debugging
		// console.info('Response:', {
		// 	status: response.status,
		// 	data: response.data
		// })
		return response
	},
	(error) => {
		// Handle 401 Unauthorized errors - force logout
		if (error.response?.status === 401) {
			// Clear any existing auth token
			if (typeof window !== "undefined") {
				document.cookie = "auth-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
				
				// Reset user profile to initial value
				useBearStore.getState().setProfileUser(initialUserProfile)
				
				// Clear all stores
				useBearStore.getState().logout()
				
				// Show toast notification
				toast.error("Hết hạn đăng nhập hoặc tài khoản đang dùng trên thiết bị khác")
				
				// Redirect to login page after a short delay to allow toast to show
				setTimeout(() => {
					window.location.href = "/auth/login/google"
				}, 1500)
			}
		}
		
		// Handle 403 Forbidden errors only for /api/carts endpoint
		if (error.response?.status === 403 && error.config?.url?.includes('/api/carts')) {
			// Clear any existing auth token
			if (typeof window !== "undefined") {
				document.cookie = "auth-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
				
				// Reset user profile to initial value
				useBearStore.getState().setProfileUser(initialUserProfile)
				
				// Redirect to login page
				window.location.href = "/auth/login/google"
			}
		}
		
		// console.error('Response Error:', {
		// 	status: error.response?.status,
		// 	data: error.response?.data,
		// 	message: error.message
		// })
		return Promise.reject(error)
	}
)
